var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { styled } from 'linaria/react';
import { ReactComponent as Check } from '../svg/Check.svg';
const CheckInput = /*#__PURE__*/styled('input')({
  name: "CheckInput",
  class: "c1i1ikgj"
});
const CheckBox = /*#__PURE__*/styled('span')({
  name: "CheckBox",
  class: "cdsc28"
});
const CheckMark = /*#__PURE__*/styled(Check)({
  name: "CheckMark",
  class: "c1bt8vbf"
});
const Label = /*#__PURE__*/styled('label')({
  name: "Label",
  class: "l13mec8q"
});

const Checkbox = _a => {
  var {
    label,
    className
  } = _a,
      props = __rest(_a, ["label", "className"]);

  return React.createElement(Label, {
    className: className || '',
    "data-testid": `checkbox-${label}`
  }, React.createElement(CheckInput, Object.assign({
    type: "checkbox"
  }, props)), React.createElement(CheckBox, null, React.createElement(CheckMark, null)), label);
};

Checkbox.Label = Label;
export default Checkbox;

require("../../../../.linaria-cache/node_modules/@jetshop/ui/Checkbox/Checkbox.linaria.css");